/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
/**
 * @deprecated Use icons from `@chilipiper/icons/figma-generated/src/icon` or
 *   `@chilipiper/icons/figma-generated/src/logo` instead
 */
export const SvgStar = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M8.452 1.277l2.082 4.125 4.007.397a.5.5 0 0 1 .31.855l-3.297 3.269 1.223 4.441a.506.506 0 0 1-.716.582l-4.063-2.012-4.056 2.01a.506.506 0 0 1-.716-.582L4.448 9.92l-3.3-3.268a.5.5 0 0 1 .311-.855L5.466 5.4l2.079-4.123a.51.51 0 0 1 .907 0z'
      strokeWidth={1.75}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
export default SvgStar
